import { useState, useEffect } from "react";

/**
 * Hook for storing a value in localStorage, keeping React state in sync.
 *
 * @param {string} key - localStorage key
 * @param {*} defaultValue - Default value if nothing stored
 */
export const useLocalStorage = (key, defaultValue = null) => {
  const [value, setValue] = useState(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored !== null ? JSON.parse(stored) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // ignore
    }
  }, [key, value]);

  return [value, setValue];
};